import React from "react";
import { withRouter, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import routes from "../../routes";

const ProtectStep = ({
  wait,
  step,
  path,
  component: Component,
  render,
  ...rest
}) => {
  const maxStep = useSelector(({ order }) => order.maxStep);

  const routeNames = ["getstarted", "template", "guestlist", "order"];

  return (
    <>
      {!wait && (
        <Route
          {...rest}
          render={props => {
            if (maxStep < step)
              return props.history.push({
                pathname: routes[routeNames[maxStep - 1]]
              });
            return <Component {...props} />;
          }}
        />
      )}
    </>
  );
};

export default withRouter(ProtectStep);
